import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Block, DefaultText, FlexRow, LogOutIcon } from '@guryou/html-components';
import { makeStyles } from '@material-ui/core/styles';
import { dealTokens } from 'components/shared';

const useStyles = makeStyles({
  box: {
    transition: `background ${dealTokens.motion.fast}`,
    '&:hover': {
      backgroundColor: dealTokens.color.canvas,
    },
    cursor: 'pointer',
  },
});

const SkipBlock = ({ title }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleClick = () => {
    history.push('/management/providers');
  };

  return (
    <Block
      onClick={handleClick}
      className={classes.box}
      xs={12}
      margin={2}
      marginLeft={0.5}
      padding={4}
      border={`1px solid ${dealTokens.color.border}`}
      borderRadius={`${dealTokens.radius.md}px`}
    >
      <FlexRow margin={0} padding={0}>
        <Block xs={10}>
          <DefaultText fontWeight={800} textDecoration="underline" textUnderlineOffset="4px" color={dealTokens.color.info}>
            {title}
          </DefaultText>
        </Block>
        <Block xs={2} display="flex" flexDirection="row" alignItems="center" justifyContent="end">
          <LogOutIcon fontSize="medium" htmlColor={dealTokens.color.info} />
        </Block>
      </FlexRow>
    </Block>
  );
};

export default SkipBlock;
